import Vue from 'vue'
import Vuex from 'vuex'
import TextField from "@/includes/fields/TextField";
import RadioButtonField from "@/includes/fields/RadioButtonField";
import CheckboxField from "@/includes/fields/CheckboxField";
import LikertField from "@/includes/fields/LikertField";
import TextAreaField from "@/includes/fields/TextAreaField";
import MaskedTextField from "@/includes/fields/MaskedTextField";
import VuexPersistence from "vuex-persist";
import {Secoes} from "@/includes/Secoes";
import {actions} from "@/store/actions";
import {mutations} from "@/store/mutations";

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

export class State {
    usuario?: Data | null = null
    aceite = false
    formularioId = ''
    formulario: Secoes = {
        perfil: {
            title: 'Perfil',
            desc: 'Compartilhe um pouco sobre sua empresa',
            fields: [
                new TextField('1. Nome da empresa'),
                new MaskedTextField('2. CNPJ', '', '##.###.###/####-##', ['##.###.###/####-##']),
                new TextField('3. Cidade'),
                new TextField('4. Email para contato',),
                new MaskedTextField('5. Telefone para contato', '', '(##) ####-####', ['(##) ####-####', '(##) #####-####']),
                new RadioButtonField('6. Setor', '', ['Indústria', 'Comércio', 'Serviços', 'Agropecuária']),
                new RadioButtonField('7. Segmento', '', [
                    'Indústria de transformação, fábricas',
                    'Empresas de base tecnológica, startups',
                    'Varejo tradicional',
                    'Agricultura, pecuária, produção florestal',
                    'Pesca, aquicultura',
                    'Bares e Restaurantes',
                    'Construção civil',
                    'Atacados, supermercados, mercados de alimentos',
                    'Farmácias, distribuição de medicamentos',
                    'Serviços de Beleza e Estética',
                    'Logística e Transporte',
                    'Oficinas de auto e moto peças',
                    'Serviços de saúde e terapia humana',
                    'Serviços de educação',
                    'Turismo',
                    'Artes e cultura',
                    'Pet shops e serviços veterinários',
                    'Informação e comunicação',
                    'Produção/realização de eventos',
                    'Frigoríficos, abatedouros',
                    'Provedores de energia, água e outros serviços básicos',
                    'Distribuidoras de Combustíveis, Postos de Serviços',
                    'Distribuição de gás de cozinha',
                    'Esporte e recreação',
                    'Atividades imobiliárias',
                    'Provedores de internet',
                    'Manutenção, reparação e serviços de informática',
                    'Atividades de gestão de resíduos e descontaminação',
                    'Outro',
                ]),
                new RadioButtonField('8. Qual foi a média mensal do faturamento do seu negócio (antes da pandemia COVID-19)?', '', [
                    'Até 7 mil por mês',
                    'De 8 à 30 mil por mês',
                    'De 31 à 100 mil por mês',
                    'De 101 à 400 mil por mês',
                    'De 401 à 1 milhão por mês',
                    'De 1,000,001 milhão à 5 milhões por mês',
                    'De 5.000,001 milhões à 10 milhões por mês',
                    'De 10,000,001 milhões à 25 milhões por mês',
                    'Acima de 25 milhões',
                    'Prefere não responder',
                ]),
            ]
        },
        impacto: {
            title: 'Impacto COVID-19 no seu funcionamento',
            desc: 'Compartilhe como a pandemia do novo coronavírus tem afetado seu negócio',
            fields: [
                new TextField('9. Qual o número de pessoas/funcionários na sua empresa hoje?', '', 'O valor deve ser um número'),
                new TextField('10. Quantas demissões desde 01 de Março de 2020?', '', 'O valor deve ser um número'),
                new CheckboxField('11. Como está o funcionamento atual da sua empresa?', [
                    ['Em atividade normal', false],
                    ['Férias coletivas parcial', false],
                    ['Férias coletivas total', false],
                    ['Teletrabalho/Home office parcial', false],
                    ['Teletrabalho/Home office total', false],
                    ['Apenas atividades de estoque e entrega', false],
                    ['Suspensão temporária das atividades', false],
                    ['Suspensão definitivas das atividades', false],
                    ['Outro', false],
                ]),
                new RadioButtonField('12. Atualmente encontra dificuldade para reposição de estoque ou aquisição de insumo para sua atividade?', '',
                    ['Sim', 'Não', 'Não se aplica']),
                new CheckboxField('13. Atualmente encontra-se em dificuldade para a escoamento ou venda de estoque/serviços?', [
                    ['Sim, escoamento', false],
                    ['Sim, venda', false],
                    ['Não, escoamento', false],
                    ['Não, venda', false],
                ]),
                new RadioButtonField('14. Sua previsão atual de estoque atende:', '',
                    ['1 semana', '2 semanas', '4 semanas', '8 semanas', 'Acima de 8 semanas', 'Não se aplica']),
            ]
        },
        impactoEconomico: {
            title: 'Impacto econômico COVID-19',
            desc: 'Como a pandemia está afetando a saúde financeira do seu negócio',
            fields: [
                new RadioButtonField('15. Como o seu negócio está sendo afetado, até este momento, pelo Coronavírus em termos de faturamento mensal?', '',
                    ['Aumentou', 'Permaneceu igual', 'Diminuiu', 'Não sabe ainda', 'Não quero responder',]),
                new LikertField('16. Qual foi a variação semanal do percentual do volume de vendas em relação a uma semana normal?',
                    ['Reduziu', 'Aumentou'],
                    [
                        'Até 10%',
                        'De 11% à 30%',
                        'De 31% à 50%',
                        'De 51% à 70%',
                        'De 71% à 90%',
                        'De 91% à 100%',
                        'Estamos fechados',
                    ]),
                new LikertField('17. Por quanto tempo acredita que possa manter seu negócio, sem fechá-lo permanentemente, com as restrições de movimentação de pessoas adotadas?',
                    ['Restrição até final de Abril 2020', 'Restrição até meio de Maio 2020', 'Restrição até final de Maio 2020', 'Até final de Junho 2020'],
                    [
                        'Até um mês',
                        'De 2 a 3 meses',
                        'De 3 a 4 meses',
                        'De 4 a 6 meses',
                        'Mais de 6 meses',
                        'Não sabe responder',
                    ]),
                new RadioButtonField('18. Você precisa pedir empréstimos para manter sua empresa em funcionamento sem gerar demissões?', '',
                    ['Sim', 'Não', 'Não sabe']),
                new RadioButtonField('19. Se pedidos de empréstimos/crédito já foram feitos, eles foram atendidos pelos bancos?', '',
                    ['Sim', 'Não', 'Não solicitei empréstimo']),
            ],
        },
        final: {
            title: 'Deixe a sua opinião',
            desc: '',
            fields: [
                new TextAreaField('20. Quais seriam as medidas mais impactantes que poderiam compensar os efeitos dessa pandemia no seu negócio?', '')
            ]
        }
    }
}

export default new Vuex.Store({
    plugins: [vuexLocal.plugin],
    state: new State(),
    mutations,
    actions,
    modules: {}
})
